import { BaseSectionTitlePlugin } from './base';
import { type CalendarSelectProps, CalendarSelectView } from '../../CalendarView/CalendarView';

export type CalendarPluginCustomData = Pick<
  CalendarSelectProps,
  'tab' | 'min_date' | 'max_date' | 'is_mobile' | 'hide_period' | 'date'
>;

/**
 * CalendarPlugin 의 기본 뷰 데이터 설정
 * @see {CalendarSelectView}
 * - date: 현재 날짜로 초기화
 * - tab: 'weekly' 탭을 기본값으로 사용
 * - is_mobile: 생성자에서 전달받은 모바일 여부 설정값을 사용
 */
export class CalendarPlugin extends BaseSectionTitlePlugin<CalendarSelectProps, CalendarPluginCustomData> {
  public ViewClass = CalendarSelectView;
  public default_view_data: CalendarSelectProps = {
    date: new Date(),
    tab: 'weekly',
    is_mobile: false,
  };

  constructor(custom_view_data?: CalendarPluginCustomData) {
    super();

    this.custom_view_data = custom_view_data;
  }

  override makeViewInstance(custom_view_data = this.custom_view_data) {
    return new this.ViewClass(this.makeViewData(custom_view_data));
  }
}
